import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.css']
})
export class BenefitsComponent implements OnInit {

  constructor( private router: Router) { }

  ngOnInit(): void {
  }
  backClicked() {
    if (this.router.navigated) {
      this.router.navigate(['/'])
    } else {
      this.router.navigate(['/'])
    }
  }


}
